import type { ComponentProps } from 'react';
import ExportCOCDropdown from './ExportCOCDropdown';
import styles from './ExportCOCDropdown.module.css';

export default function ExportCOCDropdownWrapper(
  props: Omit<ComponentProps<typeof ExportCOCDropdown>, 'trigger'>
) {
  return (
    <div className={styles.anchor}>
      <ExportCOCDropdown
        {...props}
        isFloatingToolbar
        trigger={<div className={styles.hiddenTrigger} />}
      />
    </div>
  );
}
